import { AppStore } from "./app-store"
import { AppointmentStore } from "./appointment-store"
import { AuthStore } from "./auth-store"
import { makeAutoObservable } from "mobx"

export class RootStore {
  appStore: AppStore
  authStore: AuthStore
  appointmentStore: AppointmentStore

  constructor() {
    this.appStore = new AppStore(this)
    this.authStore = new AuthStore(this)
    this.appointmentStore = new AppointmentStore(this)

    makeAutoObservable(this)
  }

  // Method to hydrate all stores
  async hydrate() {
    await Promise.all([
      this.appStore.hydrate(),
      this.authStore.hydrate(),
    ])
  }
}

declare global {
  // eslint-disable-next-line no-var
  var __MevolyRootStore: RootStore | undefined
}

const createRootStore = () => new RootStore()

export const rootStore =
  typeof window === "undefined"
    ? createRootStore()
    : (globalThis.__MevolyRootStore ??= createRootStore())
